import { useEffect, useRef, useState } from "react";
import { useGetCommitteBatchApprovalCourseListByBatchNoMutation, useLazyGetComitteBatchApprovalByBatchNumberQuery } from "../../../app/services/CommitteeApprovalManagement/CommitteApprovalManagementApi";
import MolGrid from "../../../components/Grid/MolGrid";
import { decryptAESID, encryptAESID } from "../../../utils/Encryption";
import { ViewCommitteeBatchApprovalConfig, ViewEventListConfig } from "../data/ViewCommitteeBatchApprovalConfig";
import { useNavigate, useParams } from "react-router-dom";
import { useGetCommitteBatchApprovalCPDEventListByBatchNoMutation } from "../../../app/services/CPD/CPDApi";


const ViewCommitteeBatchApprovalList = (props) => {
  const { id } = useParams();
  const batchNumber = id ? decryptAESID(id, false) : 0
  const molGrifRef = useRef();
  const [dataSource, setDataSource] = useState();
  const [gridDataSource, setGridDataSource] = useState();
  const navigate = useNavigate();
  const [paginationRequest, setPaginationRequest] = useState({
    batchNo: batchNumber,
    pageNo: 1,
    pageSize: 20,
  });
  const [getComitteBatchApprovalByBatchNumber, { isSuccess: isSuccessComitteBatchApprovalByBatchNumber, isFetching: isFetchingComitteBatchApprovalByBatchNumber, data: comitteBatchApprovalByBatchNumberData }] = useLazyGetComitteBatchApprovalByBatchNumberQuery();
  const [getCommitteBatchApprovalCourseListByBatchNo, { isSuccess: isSuccessCommitteBatchApprovalCourseListByBatchNo, isLoading: isLoadingCommitteBatchApprovalCourseListByBatchNo, data: committeBatchApprovalCourseListByBatchNoData, },] = useGetCommitteBatchApprovalCourseListByBatchNoMutation();
  const [getCommitteBatchApprovalCPDEventListByBatchNo, { isSuccess: isSuccessCommitteBatchApprovalCPDEventListByBatchNo, isLoading: isLoadingCommitteBatchApprovalCPDEventListByBatchNo, data: committeBatchApprovalCPDEventListByBatchNoData, },] = useGetCommitteBatchApprovalCPDEventListByBatchNoMutation();

  useEffect(() => {
    getCommitteBatchApprovalCourseListByBatchNo(paginationRequest);
    getCommitteBatchApprovalCPDEventListByBatchNo(paginationRequest);
  }, []);

  useEffect(() => {
    if (batchNumber) {
      getComitteBatchApprovalByBatchNumber(batchNumber);
    }
  }, []);

  useEffect(() => {
    if (!isFetchingComitteBatchApprovalByBatchNumber && isSuccessComitteBatchApprovalByBatchNumber && comitteBatchApprovalByBatchNumberData) { }
  }, [isFetchingComitteBatchApprovalByBatchNumber, isSuccessComitteBatchApprovalByBatchNumber, comitteBatchApprovalByBatchNumberData]);

  useEffect(() => {

    if (!isLoadingCommitteBatchApprovalCourseListByBatchNo && isSuccessCommitteBatchApprovalCourseListByBatchNo && committeBatchApprovalCourseListByBatchNoData) {
      setPaginationRequest((prev) => ({ ...prev, totalCount: committeBatchApprovalCourseListByBatchNoData.totalCount, }));
      setDataSource(committeBatchApprovalCourseListByBatchNoData?.itemList);
    }
  }, [isLoadingCommitteBatchApprovalCourseListByBatchNo, isSuccessCommitteBatchApprovalCourseListByBatchNo, committeBatchApprovalCourseListByBatchNoData,]);

  useEffect(() => {
    if (!isLoadingCommitteBatchApprovalCPDEventListByBatchNo && isSuccessCommitteBatchApprovalCPDEventListByBatchNo && committeBatchApprovalCPDEventListByBatchNoData) {
      setPaginationRequest((prev) => ({ ...prev, totalCount: committeBatchApprovalCPDEventListByBatchNoData.totalCount, }));
      setGridDataSource(committeBatchApprovalCPDEventListByBatchNoData?.itemList);
    }
  }, [isLoadingCommitteBatchApprovalCPDEventListByBatchNo, isSuccessCommitteBatchApprovalCPDEventListByBatchNo, committeBatchApprovalCPDEventListByBatchNoData,]);


  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = {
      ...paginationRequest,
      pageNo: pageNumber,
      pageSize: pageSize,
    };
    setPaginationRequest(updatedPaginationRequest);
    getComitteBatchApprovalByBatchNumber(updatedPaginationRequest);
  };

  const handleProcessClick = (data) => {
    if (data?.cpdEventId > 0) {
      window.open(`/editCpdEvent/${encryptAESID(data.cpdEventId)}`)
    }
    else {
      window.open(`/editCourseProvider/${encryptAESID(data.gmpCourseProviderId)}`)
    }
  }

  const actionHandler = {
    View: handleProcessClick,
  };

  const handleBack = () => {
    navigate('/committeeBatchApproval/CommitteeBatchApproval')
  }

  return (
    <>
      <div>
        <div className="commitee-table-title d-flex justify-content-between align-items-center">
          <span>Batch Number: {batchNumber}</span>
          <div className="d-flex gap-5">
            <h3 className="mb-0 commitee-table-data">
              Sent Date: {comitteBatchApprovalByBatchNumberData?.sentDate ? new Date(comitteBatchApprovalByBatchNumberData.sentDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', }) : ''}
            </h3>
            <h3 className="mb-0 commitee-table-data">
              Link Close Date: {comitteBatchApprovalByBatchNumberData?.linkCloseDate ? new Date(comitteBatchApprovalByBatchNumberData.linkCloseDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', }) : ''}
            </h3>
          </div>
        </div>
        <div className="list-card">
          <div className="list-title">Course Provider</div>
          <MolGrid
            configuration={ViewCommitteeBatchApprovalConfig}
            ref={molGrifRef}
            dataSource={dataSource}
            handlePageChange={handlePageChange}
            pagination={paginationRequest}
            allowPagination={true}
            isLoading={isLoadingCommitteBatchApprovalCourseListByBatchNo}
            onActionChange={actionHandler}
          />
        </div>
        <div className="list-card">
          <div className="list-title">Events</div>
          <MolGrid configuration={ViewEventListConfig}
            ref={molGrifRef}
            dataSource={gridDataSource}
            handlePageChange={handlePageChange}
            pagination={paginationRequest}
            allowPagination={true}
            isLoading={isLoadingCommitteBatchApprovalCPDEventListByBatchNo}
            onActionChange={actionHandler}
          />
        </div>
        <div className="list-btn-sec">
          <button type="button" className="black-btn btn" onClick={handleBack}>
            Back
          </button>
        </div>
      </div>
    </>
  );
};
export default ViewCommitteeBatchApprovalList;
